import * as ACTION from '../actions/actionTypes';
import { UpdateObject } from '../../utils/utils';

const initialState = {
    loading: false,
    errorMsg: '',
    data:[],
   // calendarData:[]
}

const NetworkGraphCdsnReducer = (state = initialState, action) => {
    switch(action.type) {
       
        case ACTION.GET_NETWORK_GRAPH_CDSN_REQUEST: return getNetworkGraphCdsnRequest(state, action);
        case ACTION.GET_NETWORK_GRAPH_CDSN_SUCCESS: return getNetworkGraphCdsnSuccess(state, action);
        case ACTION.GET_NETWORK_GRAPH_CDSN_FAILURE: return getNetworkGraphCdsnFailure(state, action);
        
        default: return state;
    }
}

const getNetworkGraphCdsnRequest = (state, action) => {
    return UpdateObject(state, {
        loading: true,
    });
}
const getNetworkGraphCdsnSuccess = (state, action) => {
    return UpdateObject(state, {
        loading: false,
        data: action.payload,
    });
}
const getNetworkGraphCdsnFailure = (state, action) => {
    return UpdateObject(state, {
        loading: false,
        errorMsg: action.payload,
    });
}

export default NetworkGraphCdsnReducer;